export const removeZero = (cpf: string) => {
  const temp = parseInt(cpf, 10);
  return temp.toString();
};
